import { z } from "zod";

const requiredString = (message) => z.string().trim().min(1, message);

const hexColorSchema = requiredString("Color is required").regex(
  /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
  "Enter a valid hex color",
);

export const createOrganisationStepOneSchema = z.object({
  organisationName: requiredString("Organisation name is required"),
  brandUsername: requiredString("Brand username is required")
    .regex(/^\S+$/, "Spaces are not allowed")
    .refine((value) => !/^\d+$/.test(value), {
      message: "Only numbers are not allowed",
    }),
  industryType: requiredString("Industry type is required"),
  contactNumber: z
    .string()
    .trim()
    .min(7, "Contact number must be at least 7 digits")
    .max(20, "Contact number must not exceed 20 digits")
    .regex(/^[+]?[0-9\s\-()]+$/, "Enter a valid contact number"),
  contactEmail: requiredString("Contact email is required").email(
    "Enter a valid email address",
  ),
  addressLine1: requiredString("Organisation address is required"),
  city: requiredString("City is required"),
  state: requiredString("State is required"),
  zip: requiredString("Zip is required"),
  website: z
    .string()
    .trim()
    .optional()
    .refine(
      (val) =>
        !val || /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/.test(val),
      "Please enter a valid website",
    ),
  deepLink: z
    .string()
    .url("Please enter a valid URL")
    .optional()
    .or(z.literal("")),
});

export const createOrganisationStepTwoSchema = z.object({
  uploadLogo: z.any().refine((value) => {
    if (!value) return false;
    if (Array.isArray(value)) return value.length > 0;
    return true;
  }, "Logo is required"),

  primaryColor: hexColorSchema,
  secondaryColor: hexColorSchema,
});

export const createOrganisationStepThreeSchema = z.object({
  campaignName: requiredString("Campaign name is required"),
  campaignDescription: requiredString("Campaign description is required"),
  campaignAccessType: requiredString("Campaign access type is required"),

  allowedDomains: z
    .array(
      z
        .string()
        .trim()
        .toLowerCase()
        .refine(
          (value) => {
            // reject emails
            if (value.includes("@")) return false;

            // valid domain only
            return /^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/.test(value);
          },
          {
            message: "Only valid domain names are allowed",
          },
        ),
    )
    .min(1, "At least one domain is required"),

  invitedEmails: z
    .array(z.string().trim().toLowerCase().email("Invalid email address"))
    .optional()
    .default([]),
  // joinCode: requiredString("Join code is required"),
});
// .superRefine((data, ctx) => {
//   const { invitedEmails, allowedDomains, campaignAccessType } = data;

//   // validation only for invite only
//   if (campaignAccessType !== "INVITE_ONLY") return;

//   // empty emails validation
//   if (invitedEmails.length === 0) {
//     ctx.addIssue({
//       code: z.ZodIssueCode.custom,
//       path: ["invitedEmails", 0],
//       message: "At least one email is required",
//     });

//     return;
//   }

//   invitedEmails.forEach((email, index) => {
//     const emailDomain = email.split("@")[1];

//     const isAllowed = allowedDomains.includes(emailDomain);

//     if (!isAllowed) {
//       ctx.addIssue({
//         code: z.ZodIssueCode.custom,
//         path: ["invitedEmails", index],
//         message: `Email must belong to: ${allowedDomains.join(", ")}`,
//       });
//     }
//   });
// });

export const createOrganisationSchema = createOrganisationStepOneSchema
  .merge(createOrganisationStepTwoSchema)
  .merge(createOrganisationStepThreeSchema);
